/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Other_Option14Inputs */

const en__field_enum_mzs_other_option14 = /** @type {(inputs: _Field_Enum_Mzs_Other_Option14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other`)
};

const de__field_enum_mzs_other_option14 = /** @type {(inputs: _Field_Enum_Mzs_Other_Option14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

/**
* | output |
* | --- |
* | "other" |
*
* @param {_Field_Enum_Mzs_Other_Option14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_other_option14 = /** @type {((inputs?: _Field_Enum_Mzs_Other_Option14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Other_Option14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_other_option14(inputs)
	return de__field_enum_mzs_other_option14(inputs)
});
export { _field_enum_mzs_other_option14 as "_field_enum_MZS_OTHER_OPTION" }